// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';
import { WSSupport } from '../utils/WSSupport';

export const WSSupportContext = React.createContext<WSSupport | undefined>(undefined);

export const useWSSupport = () => {
  const wsSupport = useContext(WSSupportContext);
  if (!wsSupport) {
    throw new Error('WSSupport is not initialized');
  }
  return wsSupport;
};
